import React from 'react'
import { FieldHookConfig, useField } from 'formik'

import { LabeledCheckbox } from '@carsys/ui'
import { useFormSection } from './FormSection'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface CheckboxProps
  extends Omit<
      React.ComponentProps<typeof LabeledCheckbox>,
      'component' | 'checked' | 'defaultChecked' | 'defaultValue' | 'name' | 'value' | 'onChange'
    >,
    Pick<FieldHookConfig<boolean>, 'name' | 'validate'> {
  onChange?: (checked: boolean) => void
}

export function Checkbox({ name, validate, onChange, ...props }: CheckboxProps) {
  const [input, , helpers] = useField<boolean>({ name, type: 'checkbox', validate })
  const formSection = useFormSection()

  useRegisterFormField(name)

  const changeHandler = (_: React.ChangeEvent<{}>, checked: boolean) => {
    helpers.setValue(checked)
    if (onChange) {
      onChange(checked)
    }
  }

  return <LabeledCheckbox disabled={formSection.disabled} id={input.name} {...props} {...input} onChange={changeHandler} />
}
